import "../theme/Administracion.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { TableAdministracionFaltantes } from "../components/TableAdministracionFaltantes";
import { authProvider } from "../context/authProvider";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageFaltantes = () => {
  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Administración Faltantes" />
              </div>
              <TableAdministracionFaltantes />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
